<template>
  <div class="search-wrapper">
    <div class="search-close" @click="hide"></div>
    <div class="search-body-wrapper">
      <div class="search-header flex justify-center items-center">
        <div class="search-box flex">
          <div class="search-icon flex items-center justify-center">
            <img src="./assets/images/search/search.png" alt="" />
          </div>

          <input
            class="appearance-none "
            type="text"
            placeholder="搜索"
            @keyup.enter="search"
            v-model="keywords"
          />
          <div
            class="search-btn flex items-center justify-center cursor-pointer"
            @click="search"
          >
            <img src="./assets/images/search/jiantou.png" alt="" />
          </div>
        </div>
      </div>
      <div class="search-body mx-auto" v-if="list && list.length > 0">
        <div
          class="item flex cursor-pointer"
          v-for="(item, index) in list"
          :key="'search' + index"
          @click="clickItem(item)"
        >
          <div
            class="bg-image mr-6 bg-cover bg-center"
            :style="{ backgroundImage: 'url(' + item.imageUrl + ')' }"
          ></div>
          <div class="flex-1 flex flex-col justify-center ">
            <div class="content">
              <p class="mb-1">{{ item.titleZh }}</p>
              <p class="mt-2">
                {{ item.contentZh }}
              </p>
            </div>

            <p class="date" v-if="item.time">{{ '发布日期：' + item.time }}</p>
          </div>
        </div>
      </div>
      <div
        class="search-body mx-auto flex justify-center items-center"
        v-if="list && list.length == 0"
      >
        <p style="color:#333">暂无结果</p>
      </div>
    </div>
  </div>
</template>

<script>
import { searchCategory } from '@/api'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      keywords: '',
      list: null
    }
  },
  computed: {
    ...mapGetters(['layoutHorizFourData', 'threeLevelDataMap'])
  },
  async mounted() {
    await this.$store.dispatch('category/queryThreeLevel')
    console.log('++++++threeLevelDataMap++++')
    console.log(this.threeLevelDataMap)
  },
  methods: {
    hide() {
      this.$emit('close')
    },
    search() {
      searchCategory(this.keywords).then(ret => {
        let { result } = ret
        if (result) {
          this.list = result.map(c => {
            return {
              ...c,
              titleZh: c.title.zh,
              imageUrl: c.bg.md + '?x-oss-process=image/resize,h_80',
              contentZh: c.content.zh
            }
          })
        } else {
          this.list = []
        }
      })
    },
    clickItem(item) {
      this.$emit('close')
      if (item.type == 0) {
        //案例
        //作品案例
        let menuId = ''
        for (let key in this.threeLevelDataMap) {
          let arr = this.threeLevelDataMap[key]
          let three = arr.find(c => c.id === item.parent_id)
          if (three) {
            menuId = key
            break
          }
        }
        this.$router.replace({
          path: `/works/${menuId}?threeId=${item.parent_id}&fourId=${item.id}`
        })
      }
      /**
       * type =1 顶部导航栏
       * type =2 底部导航栏
       * type =3 精英人物
       * type = 4 Banner
       * type = 5 新闻动态
       * type = 6 维迈公益
       * type = 7 抗击疫情
       * type = 8 证书
       */
      if (item.type == 3) {
        this.$router.replace({
          path: '/about/team'
        })
      }
      if (item.type == 5 || item.type == 6 || item.type == 7) {
        console.log('===item.link.herf==')
        console.log(item.link.herf)
        window.open(item.link.herf, '_blank')
      }
      if (item.type == 8) {
        this.$router.replace({
          path: '/about/certfication'
        })
      }
      if (item.type == 4) {
        this.$router.replace({
          path: '/home'
        })
      }
    }
  }
}
</script>

<style lang="less">
@keyframes scale {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.search-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  overflow: hidden;
  animation: scale 0.3s ease;
  backdrop-filter: blur(5px);
  background-color: rgba(48, 54, 60, 0.8);
  .search-close {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .search-body-wrapper {
    position: absolute;
    top: 45px;
    left: 50%;
    transform: translateX(-50%);
    .search-header {
      margin: auto;
      width: 900px;
      height: 67px;
      border-radius: 3px;
      background-color: rgba(0, 0, 0, 0.6);
      .search-box {
        width: 464px;
        height: 35px;
        .search-icon {
          left: 0;
          top: 0;
          width: 30px;
          background-color: white;
          height: 35px;
          img {
            width: 15px;
            height: 15px;
          }
        }
        .search-btn {
          right: 0;
          bottom: 0;
          width: 42px;
          height: 35px;
          img {
            width: 20px;
          }
          background-color: #fdb732;
        }
        input {
          width: 100%;
          height: 100%;
          outline: none;
        }
      }
    }
    .search-body {
      width: 900px;
      margin-top: 13px;
      max-height: 507px;
      min-height: 200px;
      overflow-y: scroll;
      padding: 16px;
      background-color: white;
      .item {
        margin-top: 20px;
        &:hover {
          background-color: #eee;
        }
        .bg-image {
          width: 100px;
          height: 68px;
        }
        .content {
          font-size: 12px;
          color: #333;
          p:first-child {
            font-size: 13px;
            font-weight: bold;
          }
        }
        .date {
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
}
</style>